import { combineReducers } from 'redux';
import userForm from './user-form';

export const userSettingsReducers = combineReducers({
  userForm,
});
